import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

const Footer = ({ className }) => {
  const { t } = useTranslation('common');
  return (
    <div className={`col-sm-12 mb-30 p-0 ${className}`}>
      <footer className="bg-white p-1">
        <div className="row">
          <div className="col-md-6">
            <div className="text-center text-md-left pt-3">
              <p className="mb-0">
                {t('label.copyrightText')}
              </p>
            </div>
          </div>
          <div className="col-md-6">
            <ul className="text-center text-md-right pt-3">
              {/* {t('label.policyText')} */}
              <li className="list-inline-item">
                <NavLink to="/">{t('label.termsConditions')}</NavLink>
              </li>
              <li className="list-inline-item">
                <NavLink to="/">{t('label.PIUsePolicy')}</NavLink>
              </li>
              <li className="list-inline-item">
                <NavLink to="/">{t('label.privacyPolicy')}</NavLink>
              </li>
            </ul>
          </div>
        </div>
      </footer>
    </div>
  );
};

Footer.propTypes = {
  className: PropTypes.string,
};

Footer.defaultProps = {
  className: '',
};

export default Footer;
